import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CuttingToolType } from "@enums/cuttingToolType.enum";
import { RoughFinish } from "@enums/roughFinish.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { CuttingToolService } from "@services/cuttingTool.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";
import { ToastApiError } from "@helpers/apiError";

@Component({
	moduleId: module.id,
	selector: "cuttingTools",
	styleUrls: ["cuttingTools.css"],
	templateUrl: "cuttingTools.html"
})
export class CuttingToolsAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "Cutting Tool";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	roughFinishes: any;
	title: string;
	toolTypes: any;

	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: CuttingToolService, private protectedGridService: ProtectedGridService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.title = `${this.itemType}s`;
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.checkGridExportPermissions();
		this.toolTypes = GetPropertiesFromEnum(CuttingToolType, true);
		this.roughFinishes = GetPropertiesFromEnum(RoughFinish, true);
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}

	checkGridExportPermissions() {
		this.protectedGridService.canExport("Cutting Tools")
			.subscribe(
				(res: any) => this.canExportGrid = res.response,
				(err) => { console.log(err); ToastApiError(this.toastService, err); }
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if (result) {
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => { this.toastService.success(this.itemType + " deleted!"); this.getItems(); },
					(err) => { console.log(err); ToastApiError(this.toastService, err); }
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => { this.items = res.response.items; this.gridLoading = false; },
				(err) => { console.log(err); ToastApiError(this.toastService, err); }
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Cutting Tools";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => { console.log(err); ToastApiError(this.toastService, err); return false; }
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}
